// src/components/OrganizationsList.jsx
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Building2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import api from '../../api';
import progress2 from '../../image/progress2.gif';

export default function OrganizationsList({ sidebarOpen }) {
  const [organizations, setOrganizations] = useState([]);
  const [filteredOrgs, setFilteredOrgs] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState('');

  // Charger les organisations
  useEffect(() => {
    api.get('/organisations')
      .then((response) => {
        setOrganizations(response.data.organisations);
        setFilteredOrgs(response.data.organisations);
        setLoading(false);
      })
      .catch((err) => {
        setError(`Erreur lors du chargement : ${err.message}`);
        setLoading(false);
      });
  }, []);

  // Appliquer le filtrage et la recherche
  useEffect(() => {
    let filtered = organizations;

    if (filter) {
      filtered = filtered.filter(org => org.nomOrganisation === filter);
    }

    if (searchTerm) {
      filtered = filtered.filter(org =>
        org.nomOrganisation.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredOrgs(filtered);
  }, [searchTerm, organizations, filter]);

  // Affichage pendant le chargement
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <img src={progress2} alt="Loading" className="w-24 h-24" />
      </div>
    );
  }

  if (error) return <p className="p-4 text-red-600">{error}</p>;

  return (
    <main className="bg-white rounded-2xl shadow-inner p-4 md:p-6 w-full">
      <Navbar onSearchChange={setSearchTerm} onFilterChange={setFilter} />
      
      <div className={`grid grid-cols-1 sm:grid-cols-2 ${sidebarOpen ? 'lg:grid-cols-3' : 'lg:grid-cols-4'} gap-4 md:gap-6`}>
        {filteredOrgs.length > 0 ? (
          filteredOrgs.map((org) => (
            <Link
              key={org.id}
              to={`/admin/organisations/${org.id}`}
              className="group flex flex-col bg-white rounded-xl md:rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 p-4 md:p-5"
            >
              <div className="flex items-center mb-3 md:mb-4">
                <div className="bg-terrecuite/10 p-2 md:p-3 rounded-full">
                  <Building2 className="w-5 h-5 md:w-6 md:h-6 text-terrecuite" aria-hidden="true" />
                </div>
                <h3 className="ml-3 md:ml-4 text-lg md:text-xl font-semibold text-gray-900 group-hover:text-terrecuite transition-colors duration-300 line-clamp-1">
                  {org.nomOrganisation}
                </h3>
              </div>
              <p className="text-sm md:text-base text-gray-600 mb-3 md:mb-4 flex-grow line-clamp-2 md:line-clamp-3">
                {org.description}
              </p>
              <span className="mt-auto inline-block text-terrecuite font-medium text-sm md:text-base group-hover:underline">
                En savoir plus →
              </span>
            </Link>
          ))
        ) : (
          <div className="col-span-full text-center py-10">
            <p className="text-gray-500 text-lg">Aucune organisation trouvée</p>
          </div>
        )}
      </div>
    </main>
  );
}